import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard } from '../../Components/Common/DashboardKit';

/**
 * Shukla module landing page.
 *
 * UI-only refactor (Pass 1): swapped video <ComingSoon> for
 * <ComingSoonCard>; removed unused imports. Route is wrapped in
 * <RoleProtected requireManager> in allRoutes.js.
 */
const Shukla = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-building-2-line"
                        eyebrow="Shukla Medical"
                        title="Shukla"
                        subtitle="Tools and reports for the Shukla Medical line"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shukla" },
                        ]}
                    />

                    <ComingSoonCard
                        icon="ri-building-2-line"
                        title="Shukla workspace is coming soon"
                        message="Dedicated tools and reports for the Shukla Medical product line are being built. Use Display Boards in the meantime for live Shukla floor status."
                        tone="primary"
                        features={[
                            "Shukla-specific production reports",
                            "Component traceability",
                            "Lot release workflow",
                            "Medical-grade documentation links",
                        ]}
                        contact="Reach out to the Shukla team for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shukla;
